<template>
  <div class="stat-tile" :class="`stat-tile--${tone}`">
    <div v-if="icon" class="stat-tile__icon">
      <BaseIcon :name="icon" size="14" />
    </div>
    <div class="stat-tile__body">
      <span class="stat-tile__label">{{ label }}</span>
      <span class="stat-tile__value">{{ value }}</span>
      <span v-if="sublabel" class="stat-tile__sub">{{ sublabel }}</span>
    </div>
  </div>
</template>

<script>
  import BaseIcon from '@shared/components/BaseIcon.vue';

  export default {
    name: 'StatTile',

    components: { BaseIcon },

    props: {
      label: { type: String, required: true },
      value: { type: [String, Number], required: true },
      sublabel: { type: String, default: '' },
      icon: { type: String, default: null },
      tone: {
        type: String,
        default: 'default',
        validator: (v) => ['default', 'brand', 'sky', 'amber', 'green', 'red', 'violet'].includes(v),
      },
    },
  };
</script>

<style scoped lang="scss">
  .stat-tile {
    display: flex;
    align-items: flex-start;
    gap: 0.625rem;
    padding: 0.75rem 0.875rem;
    border-radius: 0.5rem;
    border: 1px solid var(--slate-200);
    background: white;

    &__icon {
      width: 28px;
      height: 28px;
      border-radius: 0.375rem;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      background: var(--slate-100);
      color: var(--slate-500);
    }

    &__body {
      display: flex;
      flex-direction: column;
      gap: 2px;
      min-width: 0;
      flex: 1;
    }

    &__label {
      font-size: 0.6875rem;
      font-weight: 600;
      color: var(--slate-500);
      text-transform: uppercase;
      letter-spacing: 0.04em;
    }

    &__value {
      font-size: 1.0625rem;
      font-weight: 700;
      color: var(--slate-900);
      font-variant-numeric: tabular-nums;
      line-height: 1.2;
    }

    &__sub {
      font-size: 0.6875rem;
      color: var(--slate-500);
    }

    &--brand {
      .stat-tile__icon {
        background: var(--brand-50);
        color: var(--brand-600);
      }
    }
    &--sky {
      .stat-tile__icon {
        background: var(--sky-50, var(--blue-50));
        color: var(--sky-600, var(--blue-600));
      }
    }
    &--amber {
      .stat-tile__icon {
        background: var(--amber-50);
        color: var(--amber-600);
      }
    }
    &--green {
      .stat-tile__icon {
        background: var(--green-50);
        color: var(--green-600);
      }
    }
    &--red {
      .stat-tile__icon {
        background: var(--red-50);
        color: var(--red-600);
      }
    }
    &--violet {
      .stat-tile__icon {
        background: var(--violet-50, var(--brand-50));
        color: var(--violet-600, var(--brand-600));
      }
    }
  }
</style>
